export const countrycodeselect = {
  height: {
    value: '100%',
  },
};
